import { hasCapability, isUserAboveAge, isUserInRole } from 'app/auth/utils'
import { Store } from 'app/redux/Store'

const runUserCondition = (condition) => {
  const { auth } = Store.getState()
  return condition(auth?.userInfo, auth?.featureFlags)
}

// Shared visibility predicate for a navigation entry (a route, a nav
// group, or one of the `sections` below). Extracted from the legacy
// `Sidenav` component so both it and the new section-based navigation
// gate on the exact same rules: role, minimum age, tenant theme, a
// custom `userCondition`, and — for anything with `children` — whether
// at least one child is itself visible.
export const shouldRenderNavigation = (route, currentTheme) => {
  const isRouteInTheme = route.allowedOnThemes
    ? route.allowedOnThemes.includes(currentTheme)
    : true

  // Mirrors the gating logic in `AppRoute`: when a route declares a
  // `capability`, we honour the new permission-mode-aware check (with
  // `roles` kept as the legacy fallback). Otherwise legacy role rules
  // apply unchanged.
  const accessRule = route.capability
    ? hasCapability(route.capability, { legacyRoles: route.roles })
    : !route.roles || isUserInRole(route.roles)

  const rules = [
    accessRule,
    !route.minimumAge || isUserAboveAge(route.minimumAge),
    isRouteInTheme,
    !route.userCondition || runUserCondition(route.userCondition),
    !route.children ||
      route.children.some((nav) => shouldRenderNavigation(nav, currentTheme)),
  ]

  return !rules.some((r) => !r)
}
